"use client"

import { CarTaxiFront } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CarTaxiFrontIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CarTaxiFrontIcon = component(Icon)({ as: CarTaxiFront })
